<!--
 * @Author: your name
 * @Date: 2021-12-28 15:26:11
 * @LastEditTime: 2022-01-10 13:56:54
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \petro-web-chemicals-sellerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\views\mine\personal\SetUp.vue
-->
<template>
  <div style="background-color: #fff;height: 100%">
    <Header :title=topName :is-nav="true"></Header>
    <div v-html="viewAgreement" class="protocolModal"></div>
  </div>
</template>
<script>
import request from "@/request/transactionApi";
import Header from "@/components/Header";
export default {
  components: {
    Header
  },

  data() {
    return {
      show: false,
      viewAgreement: '',
      topName:'',
    };
  },
  created() {
    this.detailsData(this.$route.query.id)
    this.titleName()
  },
  methods: {
    // 查看协议
    async detailsData(num) {
      this.viewAgreement = ''
      let params = { };
      params = {
        agreementType: num,
      };
      let data = await request.getAgreement(params);
      console.log(data);
      if (data.returnCode === "0" && data.result.totalPages > 0) {
        this.viewAgreement = data.result.dataList[0].templateHtml;
      }else if(data.returnCode === "0" && data.result.totalPages == 0){
        this.$toast.fail('暂无此协议')
      } else {
        this.$toast.fail(data.returnMessage);
      }
    },
    async titleName(){
      if (this.$route.query.id === '01'){
        this.topName ='用户协议'
      }else {
        this.topName ='隐私政策'
      }
    }
  },
};
</script>
<style lang="stylus" scoped>
.protocolModal{
  height:calc(100vh - 120px)
  overflow-y:auto
  padding:0 48px

  >:nth-child(1){
    text-indent 0 !important
    font-weight 800
  }
}
</style>
